module.exports = __webpack_public_path__ + "img/flower_nectar.28067604.png";